<script lang="ts" setup>
import { ref, inject } from 'vue';
import { CONTEXT_KEY, type Context } from './types';

defineOptions({
  name: 'CarouselNextTrigger',
});

const context = inject<Context>(CONTEXT_KEY);

if (!context) {
  console.error('Carousel.NextTrigger 必须在 Carousel.Root 组件内部使用');
}

const canScrollNext = context?.canScrollNext ?? ref(false);
const scrollNext = context?.scrollNext ?? (() => {});
</script>

<template>
  <button
    type="button"
    class="embla__button embla__button--next"
    data-scope="carousel"
    data-part="next-trigger"
    aria-label="Next Slide"
    :disabled="!canScrollNext"
    @click="scrollNext"
  >
    <slot></slot>
  </button>
</template>

<style lang="scss" scoped>
</style>
